import React from 'react'
import { Link } from 'react-router'
import styled from 'styled-components'
import Chevron from 'core-system/Icons/Actions/Chevron'
import ColorPill from 'core-system/Pill/ColorPill'
import Text from 'core-system/Text'
import palette from 'core-system/Themes/palette'
import { Locations } from 'shared/Router/Locations'
import {
  ConnectionSettings,
  connectionStatus,
  connectionSummary,
  defaultConnectionSettings,
} from './reportedUsageConnections'

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(18rem, 1fr));
  gap: 1rem;
  margin-top: 1.5rem;
`

const Card = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 1rem 1.125rem;
  border: 1px solid ${palette.grey.grey200};
  border-radius: 0.75rem;
  background: ${palette.white};
  text-decoration: none;
  color: inherit;

  &:hover {
    border-color: ${palette.grey.grey400};
  }

  &:focus-visible {
    outline: 2px solid ${palette.secondary.purple400};
    outline-offset: 2px;
  }
`

const CardCopy = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  min-width: 0;
`

const CardAside = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-shrink: 0;
`

const Arrow = styled.span`
  display: flex;
  transform: rotate(-90deg);
  color: ${palette.text.secondary};
`

export const merchantConnectionPath = (launchId: string, merchantId: string) =>
  Locations.DashboardProgramConnection.replace(
    ':launchId',
    encodeURIComponent(launchId)
  ).replace(':merchantId', encodeURIComponent(merchantId))

const MerchantConnectionList = ({
  launchId,
  merchants,
  settingsByMerchant,
}: {
  launchId: string
  merchants: { id: string; label: string }[]
  settingsByMerchant: Record<string, ConnectionSettings>
}) => (
  <Grid>
    {merchants.map((merchant) => {
      const settings =
        settingsByMerchant[merchant.id] || defaultConnectionSettings()
      const status = connectionStatus(settings)
      return (
        <Card
          key={merchant.id}
          to={merchantConnectionPath(launchId, merchant.id)}
        >
          <CardCopy>
            <Text variant='body1' fontWeight={500}>
              {merchant.label}
            </Text>
            <Text variant='caption' color={palette.text.secondary}>
              {connectionSummary(settings)}
            </Text>
          </CardCopy>
          <CardAside>
            <ColorPill color={status.color} text={status.text} />
            <Arrow>
              <Chevron width={16} height={16} />
            </Arrow>
          </CardAside>
        </Card>
      )
    })}
  </Grid>
)

export default React.memo(MerchantConnectionList)
